import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { BlockType } from '../../@types/BlockType';

export class SkyElement extends AbstractBlock {
  toXmlFromSubBlockCustom(dom: HTMLElement): void {
    dom.appendChild(ShapeSettings.getWhiteColorInputValueXML());
  }

  defineBlock(block: BlockType): void {
    // ブロックの属性をセット
    ColorSettings.setEnvironmentColor(block);
    ShapeSettings.setElementShape(block);

    ShapeSettings.setTitleField(block, this.title);
    ShapeSettings.addColorInput(block);
    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const color = CodeSetting.getColorInputValue(block);
    let attribute = CodeSetting.getSubAttributeCode(block);
    // attribute +=  " color = '"  + color + "' ";
    attribute += CodeSetting.getAttributeCode('color', color);

    const str = CodeSetting.getElementCode(this.name_for_code, attribute, block.id, '');
    return str;
  }
}
